import { createContext, useContext } from 'react';

import { Bonus } from './lib/bonus';

interface ReactionContextValue {
	bonus: Bonus;
}

export const ReactionDetailsContext = createContext({
	bonus: {},
} as ReactionContextValue);

export const useReactionContext = () => useContext(ReactionDetailsContext);
